import secondaryComponents from "..";
import { BankEmptyIcon } from "../../../assets/svgIcons";
import useGeneralLedgerTable from "./useGeneralLedgerTable";

const GeneralLedgerTable = ({
  banks,
  handleFetchbanks,
  gotoPage,
  metaDetails,
}) => {
  const { instance } = useGeneralLedgerTable({
    banks,
    handleFetchbanks,
  });
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    instance;
  return (
    <div>
      <secondaryComponents.TableHelper
        getTableProps={getTableProps}
        getTableBodyProps={getTableBodyProps}
        headerGroups={headerGroups}
        rows={rows}
        prepareRow={prepareRow}
      >
        <div className="text-center mt-5">
          <BankEmptyIcon />
          <h5>You have no transactions</h5>
          <p>When you do, they would appear here.</p>
        </div>
      </secondaryComponents.TableHelper>
      {banks?.length > 0 && (
        <div className="mt-auto">
          <secondaryComponents.Pagination
            totalPageNumber={metaDetails?.last_page}
            handlePageClick={(value) => gotoPage(value?.selected + 1)}
            currentPage={metaDetails?.current_page}
          />
        </div>
      )}
    </div>
  );
};

export default GeneralLedgerTable;
